// Libraries
import { Game, Winner } from '../../../features/session/sessionModels';

// Styles
import styles from './PatternWinners.module.css';

/**
 * @function PatternWinners
 * List of pattern winners
 *
 * @example
 * return (
 *   <PatternWinners gameMeta={} winners={[]} />
 * )
 */
function PatternWinners({
    gameMeta,
    winners,
}: PatternWinnersProps): JSX.Element {
    return (
        <>
            <picture className={styles.picture}>
                <img
                    src={`https://${process.env.REACT_APP_CDN}/play-bingo/images/graphics/graphic-winner.svg`}
                    alt=""
                />
            </picture>
            <ul className={styles.winners}>
                {winners.map(({ username, patternId, points }) => {
                    const pattern = gameMeta?.game.gamePatterns.find(
                        ({ pattern }) => pattern.id === patternId,
                    );
                    return (
                        <li key={`${username}-${patternId}`}>
                            {username} won {points} PP
                            {pattern !== undefined && ` on ${pattern.name}`}
                        </li>
                    );
                })}
            </ul>
        </>
    );
}

/**
 * @interface PatternWinnersProps
 * Describes the properties required for the PatternWinners component
 *
 * @property {Game} gameMeta
 * @property {Winner} winners
 */
export interface PatternWinnersProps {
    gameMeta: Game;
    winners: Winner[];
}

// Exports
export default PatternWinners;
